import React from "react";

export const CheckoutMenu = () => {
  return (
<svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.8859 17.4988H4.11355C3.17262 17.4988 2.38247 16.7917 2.27847 15.8563L1.23047 6.42188H14.7689L13.7209 15.8563C13.6169 16.7917 12.8268 17.4988 11.8859 17.4988Z" stroke="#775FD5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.92188 8.88462V4.57692C4.92188 2.87785 6.29972 1.5 7.9988 1.5C9.69788 1.5 11.0757 2.87785 11.0757 4.57692V8.88462" stroke="#775FD5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.30859 8.88281H5.53936" stroke="#775FD5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.4609 8.88281H11.6917" stroke="#775FD5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.15234 13.1938L7.9985 14.4246L10.46 11.3477" stroke="#775FD5" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};
